import React, { createContext, useCallback, useState, useContext } from 'react';
import { Cookies } from 'react-cookie';
import IAddress from '~/interfaces/IAddress';

interface UserData {
  uid: string;
  name: string;
  whatsapp: string;
  orderAddress?: IAddress;
}

interface AuthState {
  user: UserData;
}

export interface SignUpData {
  name: string;
  whatsapp: string;
}

interface AuthContextData {
  updateUser(user: UserData): void;
  user: UserData;
  signOut(): void;
}

const cookies = new Cookies();
const { REACT_APP_APP_NAME } = process.env;

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const AppAuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const user = cookies.get(`@${REACT_APP_APP_NAME}:client`);

    if (user) {
      return {
        user,
      };
    }
    return {} as AuthState;
  });

  const updateUser = useCallback(
    user => {
      setData({
        ...data,
        user: { ...data.user, ...user },
      });

      cookies.set(`@${REACT_APP_APP_NAME}:client`, JSON.stringify(user), {
        path: '/',
      });
    },
    [data],
  );

  const signOut = useCallback(() => {
    cookies.set(`@${REACT_APP_APP_NAME}:client`, JSON.stringify({}), {
      path: '/',
    });

    cookies.remove(`@${REACT_APP_APP_NAME}:client`);

    setData({} as AuthState);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        updateUser,
        signOut,
        user: data.user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export function useAppAuth(): AuthContextData {
  const context = useContext(AuthContext);
  return context;
}
